import CrmEnrichmentJobSettings from "app/pages/sales-intelligence/modules/crm-enrichment/components/wizard/CrmEnrichmentJobSettings";
import type { ICountryObject } from "app/services/CountryService";

import type { CrmEnrichmentI18nKeys } from "../../../types/translations";
import type {
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    LeadScoreRefreshDataInterval,
} from "../../../types/types";
import CrmEnrichmentJobWizardHeader from "../CrmEnrichmentJobWizardHeader";

import { StyledCrmEnrichmentJobSettingsWrapper } from "./styles";

type Props = {
    selectedJobType: CrmEnrichmentJobType | "";
    selectedJobObject: CrmEnrichmentJobObject | "";
    jobObjectOptions: readonly CrmEnrichmentJobObject[];
    selectedCountry: ICountryObject;
    selectedJobRefreshPeriod: CrmEnrichmentJobRefreshPeriod;
    selectedLeadScoreRefreshDataInterval?: LeadScoreRefreshDataInterval | "";
    selectedEnrichmentSource: CrmEnrichmentSource;
    translationKeys: CrmEnrichmentI18nKeys;
    onSelectJobObject: (object: CrmEnrichmentJobObject) => void;
    onSelectJobRefreshPeriod: (period: CrmEnrichmentJobRefreshPeriod) => void;
    onSelectLeadScoreRefreshDataInterval?: (interval: LeadScoreRefreshDataInterval | "") => void;
    onSelectCountry: (country: ICountryObject) => void;
    onSelectEnrichmentSource: (source: CrmEnrichmentSource) => void;
};

const CrmEnrichmentJobSettingsWizardStep = ({
    jobObjectOptions,
    selectedJobType,
    selectedJobObject,
    selectedJobRefreshPeriod,
    selectedLeadScoreRefreshDataInterval,
    selectedEnrichmentSource,
    selectedCountry,
    translationKeys,
    onSelectJobRefreshPeriod,
    onSelectLeadScoreRefreshDataInterval,
    onSelectJobObject,
    onSelectCountry,
    onSelectEnrichmentSource,
}: Props) => {
    return (
        <>
            <CrmEnrichmentJobWizardHeader
                titleKey="si.crm-enrichment.job-wizard.settings.title"
                descriptionKey="si.crm-enrichment.job-wizard.settings.description"
            />

            <StyledCrmEnrichmentJobSettingsWrapper>
                <CrmEnrichmentJobSettings
                    selectedJobObject={selectedJobObject}
                    translationKeys={translationKeys}
                    selectedJobType={selectedJobType}
                    selectedCountry={selectedCountry}
                    jobObjectOptions={jobObjectOptions}
                    selectedJobRefreshPeriod={selectedJobRefreshPeriod}
                    selectedLeadScoreRefreshDataInterval={selectedLeadScoreRefreshDataInterval}
                    selectedEnrichmentSource={selectedEnrichmentSource}
                    onSelectJobRefreshPeriod={onSelectJobRefreshPeriod}
                    onSelectLeadScoreRefreshDataInterval={onSelectLeadScoreRefreshDataInterval}
                    onSelectCountry={onSelectCountry}
                    onSelectJobObject={onSelectJobObject}
                    onSelectEnrichmentSource={onSelectEnrichmentSource}
                />
            </StyledCrmEnrichmentJobSettingsWrapper>
        </>
    );
};

export default CrmEnrichmentJobSettingsWizardStep;
